import handleNavigation from '@/utils/navigationUtils';

const MARKET_GRID_SENTINEL = 'main';

const openAppMarket = ({ appCodeName: requestedCodeName = '' } = {}) => {
  const appCodeName = requestedCodeName === MARKET_GRID_SENTINEL ? '' : requestedCodeName;

  return handleNavigation(appCodeName
    ? { name: 'appMarketAppInfo', params: { appCodeName } }
    : { name: 'appMarket' });
};

export default {
  openAppMarket,
};
